var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSpingoSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86 86"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 41.06,
    y1: -955.51,
    x2: 28.04,
    y2: -991.59,
    gradientTransform: "scale(1 -1) rotate(-69.49 702.59 -518.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e65935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e44e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e4422a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a71f23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 35.31,
    y1: -972.34,
    x2: 23.97,
    y2: -994.46,
    gradientTransform: "scale(1 -1) rotate(-69.49 702.59 -518.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed8540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#eb743d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e54935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd1f2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 15.7,
    y1: -964.33,
    x2: 48.14,
    y2: -949.09,
    gradientTransform: "scale(1 -1) rotate(-69.49 702.59 -518.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e65935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e44e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e4422a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a71f23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 26.99,
    y1: -958.56,
    x2: 50.73,
    y2: -950.92,
    gradientTransform: "scale(1 -1) rotate(-69.49 702.59 -518.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed8540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#eb743d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e54935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd1f2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 30.43,
    y1: -967.04,
    x2: 50.76,
    y2: -961.56,
    gradientTransform: "scale(1 -1) rotate(-69.49 702.59 -518.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcef91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f3bd61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f3bb5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f1b35b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f0a551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ee9244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#e97732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e76d2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 37.93,
    y1: -977.54,
    x2: -0.54,
    y2: -975.55,
    gradientTransform: "scale(1 -1) rotate(-69.49 702.59 -518.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e65935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e44e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e4422a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a71f23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 25.26,
    y1: -973.89,
    x2: 2.86,
    y2: -964.5,
    gradientTransform: "scale(1 -1) rotate(-69.49 702.59 -518.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3bd61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f1ad56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ea8139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e76d2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 18.53,
    y1: -980.32,
    x2: 1.09,
    y2: -953.73,
    gradientTransform: "scale(1 -1) rotate(-69.49 702.59 -518.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e65935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e44e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e4422a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a71f23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 13.57,
    y1: -972.72,
    x2: 2.69,
    y2: -950.38,
    gradientTransform: "scale(1 -1) rotate(-69.49 702.59 -518.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed8540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#eb743d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e54935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd1f2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 11.43,
    y1: -955.29,
    x2: 41.13,
    y2: -973.13,
    gradientTransform: "scale(1 -1) rotate(-69.49 702.59 -518.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcef91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f3bd61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f3bb5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f1b35b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f0a551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ee9244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#e97732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e76d2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 8.63,
    y1: -967.51,
    x2: 40.14,
    y2: -967.14,
    gradientTransform: "scale(1 -1) rotate(-69.49 702.59 -518.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcef91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f3bd61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f3bb5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f1b35b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f0a551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ee9244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#e97732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e76d2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 8.07,
    y1: -976.71,
    x2: 35.97,
    y2: -976.39,
    gradientTransform: "scale(1 -1) rotate(-69.49 702.59 -518.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcef91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f3bd61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f3bb5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f1b35b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f0a551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ee9244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#e97732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e76d2b"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-7{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4 30.4c-3.5 4.4-6.6 9.2-6.8 18.5C14 38.7 20.1 25 31 22.7c-9.6 2.1-15.4 11-19 19.6 2-5.1 4.5-10.1 8.1-14.3-2.5 2.8-5 5.7-6.2 9.2 3-9.8 13.1-17.4 23.6-15.8 5.1.8 11.8 4.8 10.5 10.9-2.1 4.5-9.1 3.2-11.8 7.7-6.2 7.4-3.4 18 2.9 24.3-.7-.8-1.2-1.6-2-2.3.9 1.2 1.8 2.4 2.6 3.6-1.1-1.6-2.6-3-3.7-4.6.9 1.9 2.6 3.5 3.3 5.4-1.1-1.9-2.7-3.5-3.9-5.4 2.2 7 2.2 9 10.1 11.7-6.4-1.7-10.7-7.3-12.9-13.3 3.1 6.9 8.4 14.7 16.5 16.7-9.1-1.9-15.3-7.5-19-16.3 3.3 7.8 9 14.7 15.8 17.1-11.4-3.6-19.1-12.7-20.1-24.6C23.3 66.1 38.6 75.8 50.1 80H50c-13-2.6-25.9-13.5-26.7-27.3-.9 20.7 23.8 32.6 41.9 28-4.2 1-8.6 1.2-12.9.8 8.1.9 16.8-.5 24.3-3.8-16.9 8-41.2 6.2-51.3-11.4 4.8 9.8 16.1 15 26.4 16.1-2.4-.1-4.7-.7-7-1.2 5.8 1.5 11.8 2.1 17.7 1.5-5.8.6-11.7.4-17.4-1.1 2.3.5 4.5 1.2 6.9 1.4-21.7-.5-44.1-27.1-27.1-46.5C11.3 50.3 21.4 71.8 36 80.4c-5.7-2.8-10.3-7.8-8.1-5.7C14.8 63.5 10.5 37 29.1 29c-12.7 4.6-15.2 21-12.6 32.2-3.4-12.9-1.1-32.6 13.8-36.9-12.3 3.4-17 17.4-16.8 28.9-.1-7.3.6-15.1 5.7-21.1l.2-1.7z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 26.9c6.3-5.9 23.9-6.5 24 4.7-5.2 4.9-11.2 4.5-13.7 13.8-.6 6.8-1.7 14.8 1.5 21q1.3 1.9 0 0c-4.3-4.7-6.5-12.7-4.9-18.9-1 3.7-1.1 7.6-1.1 11.4-.1-1.1-.3-2.2-.3-3.3-.5 3.8-.3 7.8 2.2 11-3.2-4.2-4.2-9.7-3.8-14.8-.2.9-.3 1.9-.6 2.7.4-3.9 1.1-7.7 3-11.1-2 1.8-2.7 4.5-3.7 6.8.3-1.6.9-3.3 1.6-4.8C19 58.5 32.1 72 43.5 77.7c-13.1-5.6-26.3-22.8-16.2-36.4C12.6 59.2 34.8 81.6 53.7 82c-17.9-.6-36.3-16.6-31.6-35.6-4.5 15.9 7.5 31.6 23 35.1-23.7-4.2-37.9-40.4-11-50.4-14.7 2.8-20.2 19.7-13.8 32.2-7.7-13-.5-37.9 17.7-35.3-7.7-4.7-17.3 2.7-20.3 10 3.5-8.2 12.9-16 22.2-12.7-3.5-1.5-7.7-1-11.2.5 3.3-1.6 7.4-2.1 10.9-.8-6.4-3.4-14.5.1-19.1 5.1 2.9-3.5 7.5-6 12-6.7-3.6.6-7.4 1.9-10.1 4.4.3-.3.7-.6 1.1-.9z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7 72.4c5.6-.6 14.6-3.5 19.3-6.4-8.3 5.8-24.4 10.3-33.7 4.3 8.3 5.3 19.9 3 28.6-.4-5 2.1-11.6 5-17.1 4.3 3.2.4 10.1.1 13.5-1.5-9 4.8-24.1 2.4-30.4-6.2-3.2-4.2-4.9-11.8.2-15.1 4.7-1.7 8.7 4.2 13.8 3 9.6-.8 26.6-14.1 18.7-35.2 6.1 16.3 3.2 26-4.3 34.1 8.3-9.1 9.5-21.9 6.3-32.2 4.2 6.9 6.1 25.2-2.6 33.4C83.2 40.4 70 8.9 53.6 2c14.9 6.3 25 24.3 22.4 41.6 1.3-8.9 1.7-18.1-6.6-31.6 15 15.7 11.7 51.3-14.1 52.9 19.4-.1 29.1-25.9 22.1-42.1 3.1 6.3 5 15.8 0 29 .9-2.4 5-5.1 4.5-20.2C87.6 51.3 66.2 74.8 46.6 68c11.6 4 27.1-3.6 33.6-12.7-7 10.3-24.6 21.4-37.2 14.3 11 6.3 28.4-2.2 37.2-9.5-5.9 4.8-16.8 11.7-24.5 12.3z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 72.5c-8.6-.3-21.6-12.4-13.7-20.4 2.6-.8 4.9 1.4 7.5 1.6 7 2 14.4-1.9 18.6-7.5 1.6-1.9 2.5-4.3 4.6-5.7 1.9-1 3.1-2.9 3.3-5.1-1 6.9-4.8 13.5-10.5 17.5 3.3-1.9 6.2-4.5 8.8-7.3-.7.9-1.3 1.8-2.1 2.5 3-2.4 5.7-5.3 6.2-9.3-.7 5.2-3.8 9.8-7.7 13.1.7-.5 1.6-1.1 2.3-1.5-3 2.4-6.3 4.5-10 5.7 2.6.1 5.1-1.2 7.5-2.2-1.3 1-2.9 1.7-4.5 2.3 15.4-3.1 15.6-21.9 11.5-34 5.3 13.2 2.7 34.7-14.2 37.2 23.1-2.1 23-33.7 9.9-47.3 12.3 13.1 14.1 37.3-2.7 47.5 14.5-8.1 17.7-28.7 9-42.1C86.3 38.1 71 74.1 44.9 62c12.3 8.5 28.1.5 32.5-12.9-3.8 14.7-26.5 27-37.4 12.4 2.2 8.8 14.2 10.3 21.4 7.4C53.1 72.2 41 71 36.7 62c1.4 3.6 4.7 6.2 8.3 7.5-3.5-1.2-6.7-3.8-8.3-7.2 2.2 7 10.3 10.1 17.1 9.9-4.6.4-9.6-1-13.2-3.8 3 2.2 6.6 4 10.3 4.1-.5.2-1 .1-1.4 0z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 65.4c-4.6-3-8.1-16.9-3.7-23.8C45 57.9 54.6 57.6 65.2 44c-.8 1.3-1.6 2.4-2.6 3.7 1.3-1.6 2.7-3.1 4-4.5-.6.6-.9 1.4-1.4 2 .9-1.2 1.7-2.3 2.8-3.2-3.9 4.9-7.1 10.7-13.4 13 3.3-1.4 7-2.3 9.9-4.5-1 .7-1.7 1.5-2.8 2.1 1.8-1.2 3.7-2.2 5.4-3.5-4.6 3.8-10.3 8.5-16.7 7.2 6.5 2.2 14.3 1.6 18.5-4.5-4.3 6.3-13.7 9.3-20.8 5.8 6.8 4.3 16 3.2 21.4-2.7-5.7 6.6-16.3 10-24 4.6 9.3 6.3 22.2 2.4 27.8-6.9-3.3 5.5-9 9.3-15.2 10.3 4.3-.6 8.3-2.3 11.4-5.3-7 6.9-19 8-26.8 1.5 1.3 1 2.5 2.1 3.8 3-3-1.6-5.5-3.8-7.6-6.5 3.7 5.5 11.7 11.3 19 11.1-7.3.3-20-4.8-22.6-10.9 2.1 4.9 5.3 11.7 10.6 13.2-6-.8-12.7-9.8-12.9-16.3.3 5 1.3 9.7 4.4 12.7z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 56.6c-5-21 12.8-50.3 36.3-39.5C25.2 7 7.1 27.3 4.5 42.3c1.7-21.2 30-43.9 47-25.1C43.6 7 35.9 7.8 30.4 8.1 39.7 6.8 53.3 9.3 58.7 19c-4.9-8.6-15-11.5-24.3-12.6 5.5.5 10.9 1.4 16 3.7-3.4-1.6-6.9-3.2-10.6-3.3 10.2 0 20.5 7.5 22 18.1.7 5.1-1 12.7-7.2 13.3-4.9-.7-5.7-7.8-10.8-9.1-8.6-2.3-21 4.7-24.3 13.6.7-1.8 5.2-9.9 7.1-10.4-2.8.7-6.9 6.4-8.3 11 .4-3.7 2.7-8.5 4.5-9.7-3 2.1-5.8 6.6-6.6 10.3.9-3.8 1.9-6.6 3.8-9.5-4.1 4.3-5.8 8.2-6.3 16.7.5-8.7 2.8-17.4 9.5-22.7-7.4 4-11.8 12.2-11.5 20.6C11 37.3 17.5 24.3 29 22.6c-13.8 2-21.3 21.3-18.4 33.6C7.4 43 14 25.4 27.8 20.3 7.7 25.6 8 51.9 8.6 55.8c1.1 7.3 5.8 16.7 11.2 22.9-.1 0-9.3-9-12.4-22.1z",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 17.6c.4.3 3 2.5 3.3 2.9L64 22c6.1 5.7 5.1 23.4-5.9 24.5-2.5-1.2-3-4.6-4.8-6.5-5.7-7.8-17.6-8.2-25.1-2.9 1.2-1 2.3-2.4 3.6-3.1-2.1.4-4.2 1.6-6 2.8 1.4-1 2.7-2.2 4.2-2.9-1.8.2-3.5.6-5.2 1.2 4.9-3 10.6-5.3 16.5-4.4-3.6-.7-7.4-.5-11-.2 1.1-.2 2.1-.5 3.1-.6-3.8-.2-7.5.4-10.4 3 3.8-3.5 9-5 13.9-5-.9-.1-1.8-.2-2.7-.4 3.8.1 7.5.6 10.9 2.1-1.8-1.8-4.5-2.3-6.9-3.2 1.6.1 3.2.6 4.8 1.2-13.5-7.7-27.1 6.4-27.6 18.9.9-16.3 17.6-28.4 31.8-19.3-18.5-13.5-37.1 10.1-34.3 28.6C10.3 37.6 23 19.4 42 22.3 26 19.1 12 32.8 9.9 48.1c2.1-23.8 35.7-41.2 47.6-15-3.6-14.2-25.3-19.2-37-11.8 12.2-8.9 41.6-2.5 40.3 15.4 3.9-8-3.9-17-11.2-19.5C58 20.1 66 29 63.6 38.4c1.2-3.7-1-14.6-6.2-18.9",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3 39.8c4-9 .3-19-4.4-27.1 2.9 4.7 5.3 9.7 6.5 15.1-.7-3.7-1.5-7.5-3.7-10.6 6 8.2 6.2 21-1.4 28.5-3.7 3.6-10.9 6.7-15 2-2.3-4.4 2.8-9.2.9-14.1-2.4-10-13.6-14.1-22.8-11.5 1.9-.5 3.7-1.4 5.7-1.3-2-.2-4.1 0-6.1.2 2.2-.3 5.9-2.4 8-1.7-4.6-1.6-16.9 2.6-19.3 5.5 5.2-6.2 12.7-7.8 16-7.4-5.9-.8-12.3.7-16.9 4.8 7.5-6.8 20.4-12.1 31.8-4.3-12.3-8.4-30.1-3.2-38.4 6.4C19.9 11 35.8 7.6 48 15.7 32 2.6 7.4 19.2.2 32.7c5.7-13.9 20-22.2 35.7-23.6-19.2 1.7-26 4.2-35.2 20 10.1-28 54-27.9 59.3-2.7-3.2-20-27.6-23.8-43.6-16.7 18.1-11.1 52.9.3 47.9 25C67.8 22.3 56.5 9.8 47 5.8c11.9 5 24.1 17.7 19.4 32.3 3.9-11.8-2.4-25.3-12-31.5C67.1 14.8 72 29.7 67.3 39.8z",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 31.3c1 8.6-9 23.2-18.1 16.5-1.1-2.6.7-5.4.6-8.1.7-9.9-8.2-18.2-17.6-19.3 1.6.1 3.3-.3 4.9.1-1.9-1.1-4.3-1.7-6.5-2 1.7.2 3.6.3 5.2.7-1.5-1.1-3.1-2-4.8-2.6 5.8 1.1 11.7 3.3 15.7 8-2.4-3-5.4-5.5-8.5-7.7 1 .6 1.9 1 2.8 1.7-2.8-2.7-6.1-4.9-10.1-4.8 5.2 0 10.2 2.4 14.1 5.8-.6-.7-1.3-1.4-1.8-2.1 2.9 2.6 5.4 5.5 7.1 9.1-.2-2.6-2-4.8-3.2-7.1 1.1 1.2 2.1 2.7 2.9 4.2-5.3-14.8-24.5-12-32.5-7.3 12.3-7.2 31.1-6.8 36 9.5C48.8 3.3 17.6 7.6 6.1 22.6c11.1-14.1 34.8-19.2 47.3-4-10-13.1-29.8-13-41.8-2.6C29.1-.7 66.4 9.9 58.4 37.3c6.5-13.5-3.7-28-17.5-30.4 15 1.7 30.5 22.5 17.7 35.4 8.4-3.4 8.1-15.5 4.1-22.3 4.5 7.8 5.2 19.9-3.1 25.5 3.3-1.9 5.4-5.6 6.2-9.3-.7 3.6-2.7 7.2-5.8 9.3 6.6-3.1 8.5-11.7 7.3-18.4 1.1 4.5.4 9.6-1.8 13.6 1.7-3.3 2.9-7.1 2.5-10.8v1.4z",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2 44.8c-5.9 9.9-9.3 14.4-23.8 8.2 6-1.1 12-11.5 9.9-18.8-1.8-7-1.1-6.2-6.7-9.8 1.4.6-6.5-5.1-9.9-6.7 7 2.2 12.8 5.2 16 11.4-2.5-4.9-7.1-10.1-8.8-11.7 4.8 4 10.8 8.9 11 15.7.7-7-1.8-14.8-8.7-17.9 7.1 3.3 12.4 12.1 10.5 20 2.7-7.7-.7-16.8-7.6-21.1 7.7 4.5 13.8 14.7 10.1 23.4 4.2-10.8-3-22.8-13.3-26.8 16.3 6.4 17.4 19.8 15.6 25.4-.9 3.2-2.5 6.2-4.7 8.7 4.7-4.7 9.5-10.6 7.6-17.7 1.8 6.1-.9 11.8-4 17-.3.5-.7 1.3-.1 1.8 4.7-.6 7.2-5.9 8.1-10.1-.9 5.4-2.4 10.8-9.8 13.9 2.2-.7 7.3-2.7 8.6-4.9z",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8 27.2c2.5 4.1-2 18.2-7.9 15.3-8-9.6-18.2-14-27.4-6.2 4.6-4.8 9.7-7.3 16.3-7.2-3.4-.1-6.8-.7-10.2-.1 1.1-.1 2.1-.5 3.2-.6-2 .2-4 .4-6 .7 5.4-1.3 12.1-2.9 17.1.5-4.6-4.1-11.5-6.3-17.4-3.2 6.1-3.2 15.8-3 20.4 2.5-4.1-5.9-12.9-7.6-19.7-5 7.2-3 17.1-1.4 21.3 5.7C43 21 30.8 18.6 23 24.3c11.1-8.1 24.4-2.2 28.4 5.9-.6-1.3-1.2-2.5-1.9-3.7 1.8 2.3 3 4.9 3.6 7.7-.8-5.7-2.7-11.7-7.7-15.4 4.1 3.1 4.5 2.6 9.1 12.5.2.4 1 1.6 1.2 1 .9-3.2 0-9.1-2.8-12.8 3.4 4.4 5.2 9.9 4.1 16.5l.5-.6c2.5-2 2.1-5.8 1.3-8.2z",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7 23.3c7-.1 18.6 6.2 17.2 15-3.2-7.1-13.9-3.7-17.4 1.6-4.4 5.3-3.4 18.9-2 22.1-3-5.9-4-12.5-1.6-18.8-1.2 3.4-3.7 11.2-4 13.3.3-6 .6-13.3 5.8-17.3-5.9 3.4-10.5 9.8-8.9 16.8-1.6-7.4 2.2-16.4 9.4-19.4-7.6 2.3-12.7 9.9-12 17.8-1-8.5 3.4-18.9 12.3-21-10.8 2.8-15.9 15.1-13.1 25.4-1.2-4.3-1-5.3-1.1-6.2-.3-9.5 6.5-19.5 16.3-21-1.6.3-3.1.4-4.6.8 3.1-1.1 6.3-1.5 9.5-1.3-6.3-.9-13.9-1.4-18.4 4.1 3.7-4.8 9.8-6 15.6-6.5.5-.1 1.5-.2 1.4-.9-3.2-3.3-8.9-2.2-12.7-.5 5.3-3.2 11.2-1.4 16.7-.3l1.9.6c-1.4-2.9-7.4-4.3-10.3-4.3z",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7 53.3c-6.1 4-13.8 5.2-19.6-.9 2.1 5.7 7.9 7 13.8 7.2-6.7.8-14.3-2.3-17-9.5.6 6.3 4.2 10.7 10.6 13.8-6.1-1.8-14.6-8.1-13-17-2.7 5.1.1 11.1 4 15.5-5.2-4.5-8.1-12.2-4.9-19.3-4.4 4-4.5 9.9-2.4 15.6-2.8-6-3.7-14.5 3.3-19.4-6 1.1-8 8.3-8.3 13.7-.2-7.1 2.6-15.2 10.7-17-6.1-.7-11 3.5-13 9 2-7.2 8.2-12.5 16.2-11.3-5.1-2.8-11.5-1-15.6 3.5 4.5-5.2 12.7-8.3 19.6-3.8-3.5-4.6-9.5-5.2-15.2-3.1 6.5-3 14.8-2.6 19 4-1.1-6-7.2-8.4-12.6-8.8 7.4-.4 14.4 4 16 11.6 1.3-5.8-3.3-10.5-8-13.5 6.4 2.9 11.6 9.2 9.3 17.1 4.4-4 1.1-11-1.1-15.4 4.4 5.4 6.2 13.5 1.4 19.4 5.6-2.1 5.9-9.2 5.2-14.3 1.5 7.1.4 15.1-7.1 18.5 6.4 0 9.7-5.4 11-11.2-.8 7.3-6.1 13.4-14 14.1 5.2 1.6 10.7-1.1 14.2-5.9-3.4 6.6-10.9 9.9-17.9 6.7 3.7 3.9 10.3 4.3 15.4.7z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    transform: "rotate(-20.51 44.24 43.224)",
    d: "M34.19 34.09h20.1v18.3h-20.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "bgr"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M0 0h86v86H0z"
  }))));
}
SvgLogoSpingoSpinner.displayName = 'LogoSpingoSpinner';
export default SvgLogoSpingoSpinner;